/**
 * Token handling utility functions
 * Used to handle token invalidation and logout across the application
 */

// 添加防止重复登出的标记mad修改
let isRedirecting = false;
let lastRedirectTime = 0;

/**
 * Handles token invalidation by clearing localStorage and redirecting to homepage
 * @param {string} message - Optional custom message to display
 */
export const handleTokenInvalidation = (message = '登录已失效，请重新登录') => {
  // 防止短时间内多次触发登出和跳转mad修改
  const now = Date.now();
  const MIN_REDIRECT_INTERVAL = 3000; // 3秒内不重复处理

  if (isRedirecting || (now - lastRedirectTime < MIN_REDIRECT_INTERVAL)) {
    console.log('已有登出处理正在进行，忽略此次请求');
    return;
  }

  // 设置标记，防止重复处理
  isRedirecting = true;
  lastRedirectTime = now;

  // 清除token和用户信息
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  // 保存当前页面URL以便登录后返回
  const currentPath = window.location.pathname;
  if (currentPath !== '/' && currentPath !== '/login') {
    localStorage.setItem('redirectAfterLogin', currentPath);
  }

  // 显示提示消息
  if (window.Message) {
    window.Message.error(message);
  }

  // 延迟跳转到首页
  setTimeout(() => {
    window.location.href = '/';

    // 重置标记mad修改
    setTimeout(() => {
      isRedirecting = false;
    }, 1000);
  }, 1500);
};

/**
 * Checks if an API response indicates token invalidation (code: -1)
 * @param {Object} response - The API response object
 * @returns {boolean} - True if token is invalid, false otherwise
 */
export const isTokenInvalid = (response) => {
  return response?.data?.code === -2;
};

/**
 * Processes an API response and handles token invalidation if needed
 * @param {Object} response - The API response object
 * @returns {Object} - The original response for further processing
 */
export const processApiResponse = (response) => {
  if (isTokenInvalid(response)) {
    handleTokenInvalidation(response.data.msg || '登录已失效，请重新登录');
  }
  return response;
};
